<template>
  <BreadCrumb>
    <BreadCrumbItem>{{ featuredLabel }}</BreadCrumbItem>
    <BreadCrumbItem>{{ categoryLabel }}</BreadCrumbItem>
  </BreadCrumb>
</template>
<script setup>
import { TRANSLATE_MAP } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'
import { BreadCrumb, BreadCrumbItem } from '@/components/BreadCrumb'

const route = useRoute()

const language = useLanguageStore()
const featuredLabel = computed(() => TRANSLATE_MAP[language.current]?.featured)
const categoryLabel = computed(() => {
  const { category } = route.params
  return TRANSLATE_MAP[language.current]?.[category]
})

</script>
<style scoped lang="less">
</style>
